import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchHomeDataIfNeeded } from '@/redux/modules/home';
import { fetchUpcomingCatalogsIfNeeded } from '@/redux/modules/upcomingCatalogs';

const MAX_TODAY_AUCTIONS = 20;

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return Promise.all([
        dispatch(fetchHomeDataIfNeeded()),
        dispatch(fetchUpcomingCatalogsIfNeeded(MAX_TODAY_AUCTIONS, true)),
    ]);
};
